import OrdenCompraService from "@/services/compras/OrdenCompraService";

const fetch = (context, params) => {
  return OrdenCompraService.fetch(params)
    .then(res => {
      context.commit('ORDEN_COMPRAS', res.data);
    });
};

const orden_compras = (context, params) => {
  return OrdenCompraService.fetch(params)
    .then(res => {
      context.commit('ORDEN_COMPRAS', res.data);
    });
};


export default {
  fetch,
  orden_compras,
};